import AdRotator from "../components/AdRotator"
import ServiceTiles from "../components/ServiceTiles";

const ads = [
    { image: "/images/001.jpg", alt: "Ad 1" },
    { image: "/images/002.jpg", alt: "Ad 2" },
    { image: "/images/003.jpg", alt: "Ad 3" },
  ];
//{/*<div className="container my-4"></div> */}
        
export default function Home(){
    return(
        <div>
      <AdRotator ads={ads} interval={4000} />
      <ServiceTiles />
    </div>
    );
}